import VisualizarContaBancariaModal from './VisualizarContaBancariaModal';

export default VisualizarContaBancariaModal;
